// extracted by mini-css-extract-plugin
module.exports = {"form":"form--028m7","content":"content--ONqyW","footer":"footer--JByxo"};